module.exports = __webpack_public_path__ + "img/globito.a3f9e9e5.png";